var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('h2',[_vm._v(_vm._s(_vm.heading))]),_c('v-spacer'),_vm._t("org-page-button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }